
import { useState } from 'react';
import { toast } from '@/hooks/use-toast';
import { type Contact, demoContacts } from './types';

export const useContacts = (onSelectContact: (contact: Contact) => void) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [manualEmail, setManualEmail] = useState('');
  const [showManualEntry, setShowManualEntry] = useState(false);

  const filteredContacts = demoContacts.filter(contact => 
    contact.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    contact.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectContact = (contact: Contact) => {
    onSelectContact(contact);
    toast({
      title: "Contact selected",
      description: `${contact.name} (${contact.email}) selected`,
    });
  };

  const handleManualEntry = () => {
    if (manualEmail && manualEmail.includes('@')) {
      const newContact: Contact = {
        id: `manual-${Date.now()}`,
        name: manualEmail.split('@')[0], // Simple name from email
        email: manualEmail,
      };
      onSelectContact(newContact);
      toast({
        title: "Manual contact added",
        description: `${newContact.email} added`,
      });
      setManualEmail('');
    } else {
      toast({
        title: "Invalid email",
        description: "Please enter a valid email address",
        variant: "destructive"
      });
    }
  };
  
  const handleDownloadContacts = () => {
    // Create CSV content
    const headers = ['Name', 'Email'];
    const csvRows = [headers];
    
    // Add each contact as a row
    demoContacts.forEach(contact => {
      csvRows.push([contact.name, contact.email]);
    });
    
    // Convert to CSV string
    const csvContent = csvRows.map(row => row.join(',')).join('\n');
    
    // Create a blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'givgo_contacts.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast({
      title: "Contacts downloaded",
      description: `${demoContacts.length} contacts saved to CSV file`,
    });
  };

  return {
    searchTerm,
    setSearchTerm,
    manualEmail,
    setManualEmail,
    showManualEntry,
    setShowManualEntry,
    filteredContacts,
    handleSelectContact,
    handleManualEntry,
    handleDownloadContacts,
  };
};
